import _typeof from '@babel/runtime/helpers/typeof';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import _asyncToGenerator from '@babel/runtime/helpers/asyncToGenerator';
import _regeneratorRuntime from '@babel/runtime/regenerator';
import Vue from 'vue';
import isPlainObject from 'lodash/isPlainObject';
import merge from 'lodash/merge';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import last from 'lodash/last';
import get from 'lodash/get';
import omit from 'lodash/omit';
import KDDialog from '@kdocs/kdesign-vue/lib/dialog';
import '@kdocs/kdesign-vue/lib/theme-chalk/dialog.css';
import Loading from '@kso/ui/lib/Loading';
import '@kso/ui/lib/Loading/style.css';
import pick from 'lodash/pick';
import KIcon from '@kso/ui/lib/Icon';
import '@kso/ui/lib/Icon/style.css';
import AbbrText from '@kso/ui/lib/VueAbbr';
import '@kso/ui/lib/VueAbbr/style.css';
import Button from 'element-ui/lib/button';
import 'element-ui/lib/theme-chalk/button.css';
import popupManager from '@kdocs/kdesign-vue/lib/utils/popup/popup-manager';
import { PlugCtr } from '@ecis/plugctr';

// main.vue组件中的受保护的字段参数
var RESERED_DIALOG_PROPS_KEY = ['size', 'width', 'showClose', 'closeOnPressEscape', 'closeOnClickModal', 'callback', 'terminal', 'modalAppendToBody', 'appendToBody', 'newDesign', 'showBack', 'draggable', 'lockScroll', 'modal', 'subtitle', 'showClose', 'visible'];
// wrapper.js组件中受保护的字段参数key
var RESERED_WRAPPER_PROPS_KEY = ['title', 'prefixTitle', 'suffixTitle', 'actionsTitle', 'footer'];

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

// danger
var created = {};
function deleteComponent(name) {
  var key = "KDialogWrapper".concat(name);
  try {
    delete created[key];
  } catch (e) {}
  if (!name) {
    created = {};
  }
}
function Wrapper (name, _component, opt) {
  var options = opt || {};
  var componentKey = options.componentKey;
  var key = componentKey ? "KDialogWrapper".concat(name, "_").concat(componentKey) : "KDialogWrapper".concat(name);
  var initProps = omit(options, RESERED_WRAPPER_PROPS_KEY);
  var initPropsKeys = Object.keys(initProps);
  if (!created[key]) {
    created[key] = {
      name: "KDialogWrapper".concat(name),
      components: _defineProperty({
        KIcon: KIcon,
        AbbrText: AbbrText
      }, Button.name, Button),
      data: function data() {
        return {
          title: options.title,
          props: initProps,
          processing: false
        };
      },
      computed: {
        _props: function _props() {
          var bodyProps = this.props.bodyProps || {};
          return _objectSpread(_objectSpread({}, this.props), bodyProps);
        },
        /**
         * 嵌套的业务逻辑组件主题
         *
         */
        component: function component() {
          var _this = this;
          return {
            name: "KDialogWrapper".concat(name),
            render: function render(createElement) {
              return createElement(_component, {
                ref: 'mainifest',
                props: _this._props,
                on: {
                  processing: function processing(status) {
                    return _this.onProcessing(status);
                  },
                  close: function close(action, dt) {
                    return _this.$emit('close', action, dt);
                  },
                  propsChange: function propsChange(props) {
                    var updater = merge({}, options, props);
                    _this.update(updater);
                    _this.$emit('replace', name, updater);
                  },
                  change: function change(name, options) {
                    _this.$emit('change', name, options);
                  },
                  replace: function replace(name, options) {
                    return _this.$emit('replace', name, options);
                  }
                }
              });
            }
          };
        }
      },
      methods: {
        // 监听顶层弹框close回调，需要用到的地方，注册弹框时传入onClose方法即可。
        onClose: function onClose() {
          // 手动调取内部弹框组件的关闭事件
          this.$refs.body.$refs.mainifest.onClose && this.$refs.body.$refs.mainifest.onClose();
        },
        customDialogClose: function customDialogClose() {
          var _this$$refs, _this$$refs$customDia;
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }
          // 完全自定义的右上角点击关闭过程
          (_this$$refs = this.$refs) === null || _this$$refs === void 0 || (_this$$refs = _this$$refs.body) === null || _this$$refs === void 0 || (_this$$refs = _this$$refs.$refs) === null || _this$$refs === void 0 || (_this$$refs = _this$$refs.mainifest) === null || _this$$refs === void 0 || (_this$$refs$customDia = _this$$refs.customDialogClose) === null || _this$$refs$customDia === void 0 || _this$$refs$customDia.call.apply(_this$$refs$customDia, [_this$$refs].concat(args, [this]));
        },
        customEmitClose: function customEmitClose() {
          var _this$$refs2, _this$$refs2$customEm;
          for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
          }
          // 完全自定义的 $emit('close') 关闭过程
          (_this$$refs2 = this.$refs) === null || _this$$refs2 === void 0 || (_this$$refs2 = _this$$refs2.body) === null || _this$$refs2 === void 0 || (_this$$refs2 = _this$$refs2.$refs) === null || _this$$refs2 === void 0 || (_this$$refs2 = _this$$refs2.mainifest) === null || _this$$refs2 === void 0 || (_this$$refs2$customEm = _this$$refs2.customEmitClose) === null || _this$$refs2$customEm === void 0 || _this$$refs2$customEm.call.apply(_this$$refs2$customEm, [_this$$refs2].concat(args, [this]));
        },
        update: function update(props) {
          // 过滤到保留字段
          var title = props.title;
          if (typeof title === 'function') {
            var $body = this.$refs.body.$refs.mainifest;
            this.title = title($body);
          } else if (typeof title === 'string') {
            this.title = title;
          }
          this.props = pick(merge({}, this.props, props), initPropsKeys);
        },
        onProcessing: function onProcessing(status) {
          this.processing = status;
        }
      },
      render: function render(createElement) {
        var $body = createElement('component', {
          ref: 'body',
          is: this.component
        });
        return createElement('div', [$body]);
      }
    };
  }
  return created[key];
}

var isClient = !Vue.prototype.$isServer;
// 是否为组件环境
var isWebofficeEnv = isClient && window.__WPSENV__;
var SIZE_MAPPING = {
  large: '800px',
  medium: '640px',
  small: '480px'
};
var Main = {
  render: function render() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _vm.dialogVisible ? _c('div', {
      "class": _vm.wrapperClass,
      on: {
        "dragover": _vm.onDragover,
        "dragenter": _vm.onDragenter,
        "keydown": function keydown($event) {
          $event.stopPropagation();
        }
      }
    }, [_vm.tag === 'div' ? _c('div', {
      "class": [_vm.cloudClassName, _vm.pcOfficeClassName, _vm.className]
    }, [_vm.loading ? [_c('loading')] : [_c('keep-alive', [_c(_vm.component, {
      tag: "component",
      on: {
        "change": _vm.push,
        "replace": _vm.replace,
        "close": _vm.onClose
      }
    })], 1)]], 2) : _c('kd-dialog', {
      ref: "dialog",
      staticClass: "k-dialog-box",
      "class": [_vm.cloudClassName, _vm.pcOfficeClassName, _vm.className, 'new-design', _vm.extraClass, _vm.headless ? 'is-headless' : '', _vm.hideHeader ? 'is-hide-title' : '', _vm.isEl ? 'is-el-white' : '', _vm.isPureComponent ? 'is-pure-component' : ''],
      attrs: {
        "visible": _vm.visible,
        "subtitle": _vm.subTitle,
        "width": _vm.Width,
        "draggable": _vm.draggable,
        "showBack": _vm.showBack,
        "lockScroll": _vm._lockScroll,
        "modal": _vm.newShowModal,
        "closeOnPressEscape": _vm._closeOnPressEscape,
        "closeOnClickModal": _vm._closeOnClickModal,
        "showClose": _vm._showClose,
        "modalAppendToBody": _vm._modalAppendToBody,
        "appendToBody": _vm._appendToBody,
        "beforeClose": _vm.handleClose
      },
      on: {
        "update:visible": function updateVisible($event) {
          _vm.visible = $event;
        },
        "keyup": function keyup($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
            return null;
          }
          return _vm.handleOk($event);
        }
      }
    }, [_vm.isPrefix ? _c('span', {
      attrs: {
        "slot": "prefix"
      },
      slot: "prefix"
    }, [_c(_vm.isSlotComponent(_vm.isPrefix), {
      tag: "component"
    })], 1) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "kdv-dialog__title",
      "class": {
        'with-icon': _vm.pageTitleIcon
      },
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [_vm.pageTitleIcon ? [_c('KIcon', {
      key: "icon",
      staticClass: "kdv-dialog__title-icon",
      attrs: {
        "type": _vm.pageTitleIcon
      }
    })] : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "kdv-dialog__title-text"
    }, [_vm._v(_vm._s(_vm.pageTitle))])], 2), _vm._v(" "), _vm.isSuffix ? _c('span', {
      attrs: {
        "slot": "suffix"
      },
      slot: "suffix"
    }, [_c(_vm.isSlotComponent(_vm.isSuffix), {
      tag: "component"
    })], 1) : _vm._e(), _vm._v(" "), _vm.isActions ? _c('template', {
      slot: "actions"
    }, [_c(_vm.isSlotComponent(_vm.isActions), {
      tag: "component"
    })], 1) : _vm._e(), _vm._v(" "), _vm.loading ? [_c('loading')] : [_c('keep-alive', [_c(_vm.component, {
      ref: "childrenComponent",
      tag: "component",
      on: {
        "change": _vm.push,
        "replace": _vm.replace,
        "close": _vm.onClose
      }
    })], 1)], _vm._v(" "), _vm.isFooter ? _c('div', {
      attrs: {
        "slot": "footer"
      },
      slot: "footer"
    }, [_c(_vm.isSlotComponent(_vm.isFooter), {
      tag: "component"
    })], 1) : _vm._e()], 2), _vm._v(" "), _vm.internalModal ? _c('div', {
      staticClass: "kdv-modal kso-overlay",
      "class": {
        'is-hidden': !_vm.visible
      },
      style: "z-index:" + _vm.modalZInex + ";"
    }) : _vm._e()], 1) : _vm._e();
  },
  staticRenderFns: [],
  name: 'KDialog',
  components: _defineProperty(_defineProperty(_defineProperty({}, KDDialog.name, KDDialog), "loading", Loading), "KIcon", function KIcon() {
    return import('@kso/ui/lib/Icon');
  }),
  data: function data() {
    // 部分值可能回在 ./main.js Dialog方法中覆盖初始
    return {
      tag: 'dialog',
      loading: false,
      visible: true,
      // 是否显示 Dialog， 支持 .sync 修饰符
      subTitle: '',
      delayVisible: true,
      pages: {},
      state: [],
      callback: function callback() {},
      hasClickCloseBtn: false,
      className: '',
      headless: false,
      hideHeader: false,
      pcOfficeClassName: '',
      // 增加额外字段来拓展支持PC内嵌的弹窗，用于PC内嵌复写style
      cloudClassName: '',
      extraClass: '',
      internalModal: false,
      isPureComponent: false,
      onBeforeClose: function onBeforeClose() {},
      useAnimation: false,
      draggable: false,
      showBack: false,
      dialogWrapperClass: undefined,
      mfClassName: ''
    };
  },
  computed: {
    isFirstPage: function isFirstPage() {
      return this.state.length === 1;
    },
    newShowModal: function newShowModal() {
      return this.isPureComponent ? false : this._showModal && !this.internalModal;
    },
    dialogVisible: function dialogVisible() {
      if (this.useAnimation) {
        return this.delayVisible;
      }
      return this.visible;
    },
    modalZInex: function modalZInex() {
      return popupManager.nextZIndex();
    },
    wrapperClass: function wrapperClass() {
      if (this.dialogWrapperClass !== undefined) {
        return this.dialogWrapperClass;
      }
      if (isWebofficeEnv) {
        if (this.mfClassName !== '') {
          return ['kso-microApp__container', this.mfClassName];
        }
        return 'kso-microApp__container';
      }
      if (this.mfClassName !== '') {
        return this.mfClassName;
      }
      return '';
    },
    page: function page() {
      var name = this.current.name;
      var pages = this.pages;
      return name && pages[name] || {};
    },
    pageTitle: function pageTitle() {
      if (typeof this.page.title === 'function') {
        // 兼容动态写入title场景
        try {
          return this.page.title() || this.current.data.title;
        } catch (e) {
          return this.current.data.title || '';
        }
      }
      if (this.current.data && this.current.data.title) {
        return this.current.data.title;
      }
      return this.page.title || '';
    },
    pageTitleIcon: function pageTitleIcon() {
      if (this.current.data && this.current.data.icon) {
        return this.current.data.icon;
      }
      return this.page.icon || '';
    },
    slotProps: function slotProps() {
      var _ref = this.current || {},
        name = _ref.name,
        data = _ref.data;
      if (!name) {
        return;
      }
      var props = omit(data, RESERED_DIALOG_PROPS_KEY);
      return merge({}, this.pageAttrs, props, {
        useNewLayout: this.useNewLayout
      });
    },
    isPrefix: function isPrefix() {
      return this.page.prefixTitle || this.current.data && this.current.data.prefixTitle || false;
    },
    isSuffix: function isSuffix() {
      return this.page.suffixTitle || this.current.data && this.current.data.suffixTitle || false;
    },
    isActions: function isActions() {
      return this.page.actionsTitle || false;
    },
    isFooter: function isFooter() {
      return this.page.footer || false;
    },
    terminal: function terminal() {
      // get(this.current, 'data.terminal') 允许propsChange动态改变terminal
      return this.state.length <= 1 || this.page.terminal || get(this.current, 'data.terminal');
    },
    pageAttrs: function pageAttrs() {
      return omit(this.page, ['body']) || {};
    },
    current: function current() {
      var state = last(this.state) || {};
      var name = state.name;
      var page = name && this.pages[name] || {};
      return merge({}, omit(page, ['body']) || {}, state);
    },
    // @todo 目前使用组件名标记，存在两组数据复用同一个组件的情况会有bug
    key: function key() {
      return this.current.name;
    },
    // 弹窗宽度
    Width: function Width() {
      var _this$current = this.current,
        width = _this$current.width,
        size = _this$current.size;
      return width || size && SIZE_MAPPING[size] || get(this.current, 'data.width') || '480px';
    },
    // body是否可滚动
    _lockScroll: function _lockScroll() {
      var _this$current2;
      if (((_this$current2 = this.current) === null || _this$current2 === void 0 ? void 0 : _this$current2.lockScroll) !== undefined) {
        return this.current.lockScroll;
      }
      // weboffice环境，默认false
      if (window.WPSOpenApi) {
        return false;
      }
      // 其他环境默认true
      return true;
    },
    // 是否显示关闭按钮
    _showClose: function _showClose() {
      var showClose = this.current.showClose;
      return showClose === false ? false : true;
    },
    _showModal: function _showModal() {
      var modal = this.current.modal;
      return modal === false ? false : true;
    },
    _closeOnPressEscape: function _closeOnPressEscape() {
      var closeOnPressEscape = this.current.closeOnPressEscape;
      return closeOnPressEscape === false ? false : true;
    },
    _closeOnClickModal: function _closeOnClickModal() {
      var closeOnClickModal = this.current.closeOnClickModal;
      return closeOnClickModal === false ? false : true;
    },
    // 遮罩层是否插入至 body 元素上，若为 false，则遮罩层会插入至 Dialog 的父元素上
    _modalAppendToBody: function _modalAppendToBody() {
      return typeof this.current.modalAppendToBody !== 'undefined' ? this.current.modalAppendToBody : true;
    },
    // Dialog 自身是否插入至 body 元素上（非模态框不支持）。嵌套的 Dialog 必须指定该属性并赋值为 true
    _appendToBody: function _appendToBody() {
      return typeof this.current.appendToBody !== 'undefined' ? this.current.appendToBody : false;
    },
    autoFocus: function autoFocus() {
      var autoFocus = this.current.autoFocus;
      return autoFocus === false ? false : true;
    },
    _zIndex: function _zIndex() {
      var zIndex = this.current.zIndex;
      return zIndex;
    },
    curComponent: function curComponent() {
      var _ref2 = this.current || {},
        name = _ref2.name,
        data = _ref2.data;
      if (!name) {
        return;
      }
      var props = omit(data, RESERED_DIALOG_PROPS_KEY);
      // 过滤掉配置中的保留字段
      return Wrapper(name, this.page.body, merge({}, this.pageAttrs, props, {
        useNewLayout: this.useNewLayout
      }));
    },
    component: function component() {
      return this.curComponent;
    },
    isEl: function isEl() {
      return !this.useNewLayout;
    }
  },
  watch: {
    visible: function visible(val, old) {
      var _this = this;
      var useAnimation = this.useAnimation;
      if (old && !val && !useAnimation) {
        deleteComponent();
        return;
      }
      if (useAnimation && !val) {
        if (this.isPureComponent) {
          this.delayVisible = false;
          this.$nextTick(function () {
            deleteComponent();
          });
          return;
        }
        // closed和animatioend触发不了
        setTimeout(function () {
          _this.delayVisible = false;
          _this.$nextTick(function () {
            deleteComponent();
          });
        }, 300);
      }
    },
    component: function component(v, o) {
      var _ref3 = v || {},
        vName = _ref3.name;
      var _ref4 = o || {},
        oName = _ref4.name;
      if (vName && oName && vName !== oName) {
        this.updateClassName();
        this.headless = this.page.headless === undefined ? false : this.page.headless;
        this.hideHeader = this.page.hideHeader === undefined ? false : this.page.hideHeader;
      }
    }
  },
  methods: {
    isSlotComponent: function isSlotComponent(component) {
      var _this2 = this;
      return {
        render: function render(createElement) {
          return createElement(component, {
            props: _this2.slotProps
          });
        }
      };
    },
    updateClassName: function updateClassName() {
      this.className = this.page.className;
    },
    replace: function replace(name, options) {
      this.setState(name, options, 'replace');
    },
    push: function push(name, options) {
      this.setState(name, options);
    },
    setState: function setState(name, options) {
      var _this3 = this;
      var action = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'push';
      var states = Array.from(this.state);
      if (action === 'replace') {
        states.splice(states.length - 1);
      }
      if (!options) {
        return;
      }
      this.callback = options['callback'] || function () {};
      if (this.pages[name] && this.pages[name].async && typeof this.pages[name].body === 'function') {
        // 自己提前加载组件，直接用vue的异步组件弹窗会抖动
        var result = this.pages[name].body();
        var asyncComponent = result.component ? result : {
          component: result
        };
        asyncComponent.component.then(function () {
          setTimeout(function () {
            _this3.state = [].concat(states, [{
              name: name,
              data: options
            }]);
          }, 0);
        })["catch"](function () {});
      } else {
        this.state = [].concat(states, [{
          name: name,
          data: options
        }]);
      }
    },
    // 关闭前的回调，会暂停 Dialog 的关闭, 右上角 x 按钮点击
    handleClose: function handleClose(done) {
      var _this$current3;
      if ((_this$current3 = this.current) !== null && _this$current3 !== void 0 && _this$current3.customClose) {
        var _this$$refs$childrenC, _this$$refs$childrenC2, _this$current4;
        // 完全自定义的关闭过程
        (_this$$refs$childrenC = this.$refs.childrenComponent) === null || _this$$refs$childrenC === void 0 || (_this$$refs$childrenC2 = _this$$refs$childrenC.customDialogClose) === null || _this$$refs$childrenC2 === void 0 || _this$$refs$childrenC2.call(_this$$refs$childrenC, done, this);
        ((_this$current4 = this.current) === null || _this$current4 === void 0 ? void 0 : _this$current4.destroyPageBeforeClose) && this.$refs.childrenComponent.$destroy();
      } else if (this.terminal) {
        done();
      } else {
        var _this$current5;
        var name = this.state.slice(-1)[0].name;
        this.$refs.childrenComponent.onClose && this.$refs.childrenComponent.onClose();
        ((_this$current5 = this.current) === null || _this$current5 === void 0 ? void 0 : _this$current5.destroyPageBeforeClose) && this.$refs.childrenComponent.$destroy();
        this.state.pop();
        deleteComponent(name);
      }
      this.hasClickCloseBtn = true;
    },
    // 内部的关闭
    onClose: function onClose(action, data) {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this4$current;
        var _this4$$refs$children, _this4$$refs$children2, _this4$current3, _this4$state$pop2, name;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!((_this4$current = _this4.current) !== null && _this4$current !== void 0 && _this4$current.useCustomEmitClose)) {
                _context.next = 4;
                break;
              }
              // 完全自定义的 $emit('close') 过程
              (_this4$$refs$children = _this4.$refs.childrenComponent) === null || _this4$$refs$children === void 0 || (_this4$$refs$children2 = _this4$$refs$children.customEmitClose) === null || _this4$$refs$children2 === void 0 || _this4$$refs$children2.call(_this4$$refs$children, {
                closeAll: function closeAll() {
                  return _this4.visible = false;
                },
                close: function close() {
                  var _this4$current2;
                  ((_this4$current2 = _this4.current) === null || _this4$current2 === void 0 ? void 0 : _this4$current2.destroyPageBeforeClose) && _this4.$refs.childrenComponent.$destroy();
                  var _this4$state$pop = _this4.state.pop(),
                    name = _this4$state$pop.name;
                  deleteComponent(name);
                },
                deleteComponent: deleteComponent
              }, action, data, _this4);
              _context.next = 17;
              break;
            case 4:
              if (!_this4.terminal) {
                _context.next = 11;
                break;
              }
              if (!(action === 'ok')) {
                _context.next = 8;
                break;
              }
              _context.next = 8;
              return _this4.callback(data);
            case 8:
              _this4.visible = false;
              _context.next = 17;
              break;
            case 11:
              if (!(action === 'ok')) {
                _context.next = 14;
                break;
              }
              _context.next = 14;
              return _this4.callback(data);
            case 14:
              ((_this4$current3 = _this4.current) === null || _this4$current3 === void 0 ? void 0 : _this4$current3.destroyPageBeforeClose) && _this4.$refs.childrenComponent.$destroy();
              _this4$state$pop2 = _this4.state.pop(), name = _this4$state$pop2.name;
              deleteComponent(name);
            case 17:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    onDragover: function onDragover(e) {
      e.stopPropagation();
      e.preventDefault();
      e.dataTransfer.dropEffect = 'none';
    },
    onDragenter: function onDragenter(e) {
      e.stopPropagation();
      e.preventDefault();
    }
  },
  mounted: function mounted() {
    var _this5 = this;
    if (this.autoFocus) {
      this.$nextTick(function () {
        _this5.$refs.dialog && _this5.$refs.dialog.$el.focus();
      });
    }
  }
};

/* ECIS start */
var plugctr = new PlugCtr('kso');
/* ECIS end */

var _excluded = ["title", "terminal", "closeOnClickModal", "internalModal", "useAnimation", "dialogWrapperClass", "isPureComponent", "onBeforeClose"],
  _excluded2 = ["body", "beforeVisiable"];
var DialogConstructor = Vue.extend(Main);
var instances = [];
function DialogFactory(config) {
  var entry = config.entry,
    pages = config.pages;
  var mapping = {};
  var asyncs = [];
  var _entry_;
  var instance;
  pages.forEach(function (page) {
    var body = page.body,
      _page$async = page.async,
      async = _page$async === void 0 ? false : _page$async,
      name = page.name;
    if (typeof body === 'function' && async && name) {
      mapping[name] = page;
    } else if (typeof body === 'function') {
      asyncs.push( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _body_, _page_;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return page.body();
            case 2:
              _body_ = _context.sent;
              _page_ = merge({}, page, {
                body: _body_
              });
              mapping[_body_.name] = _page_;
              if (page.body === entry.body) {
                _entry_ = _body_.name;
              }
              return _context.abrupt("return", _page_);
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee);
      })));
    } else if (entry && entry.name) {
      var _name = body.name;
      mapping[_name] = page;
      _entry_ = _entry_ || entry.name === _name && _name;
    } else {
      var _name2 = body.name;
      mapping[_name2] = page;
    }

    /* ECIS start */
    /* @Description: 修复宿主方title翻译不生效 */
    var temp = Object.assign({}, page);
    var props = {};
    Object.keys(page).forEach(function (key) {
      if (key === 'title') {
        props[key] = {
          enumerable: true,
          configurable: true,
          set: function set(value) {
            page[key] = value;
          },
          get: function get() {
            if (Object.prototype.toString.call(temp[key]) === '[object Function]') {
              var _title = temp[key];
              return function () {
                var resData = _title.call.apply(_title, arguments);
                var resText = resData ? resData.title || '' : '';
                return plugctr.ask('translate', {
                  key: resText,
                  text: resText
                }) || resText;
              };
            }
            return plugctr.ask('translate', {
              key: temp[key],
              text: temp[key]
            }) || temp[key];
          }
        };
      }
    });
    Object.defineProperties(page, props);
    /* ECIS start */
  });
  var Dialog = function Dialog(options) {
    if (Vue.prototype.$isServer || instance) {
      return;
    }

    // eslint-disable-next-line
    options.title;
      options.terminal;
      options.closeOnClickModal;
      var _options$internalModa = options.internalModal,
      internalModal = _options$internalModa === void 0 ? false : _options$internalModa,
      _options$useAnimation = options.useAnimation,
      useAnimation = _options$useAnimation === void 0 ? false : _options$useAnimation,
      _options$dialogWrappe = options.dialogWrapperClass,
      dialogWrapperClass = _options$dialogWrappe === void 0 ? undefined : _options$dialogWrappe,
      _options$isPureCompon = options.isPureComponent,
      isPureComponent = _options$isPureCompon === void 0 ? false : _options$isPureCompon,
      onBeforeClose = options.onBeforeClose,
      data = _objectWithoutProperties(options, _excluded);
    instance = new DialogConstructor({
      data: merge(data, {
        loading: false,
        visible: false,
        pages: {},
        state: [],
        isPureComponent: isPureComponent,
        internalModal: internalModal,
        useAnimation: useAnimation,
        onBeforeClose: onBeforeClose,
        dialogWrapperClass: dialogWrapperClass
      })
    });
    instance.$mount();
    instances.push(instance);
    var isWebofficeEnv = !Vue.prototype.$isServer && window.__WPSENV__;
    var container = null;
    if (!isWebofficeEnv) {
      container = options.container || document.body;
    } else {
      if (options.container && options.container !== document.body) {
        container = options.container;
      } else {
        var id = 'kma-popper__container';
        container = document.getElementById(id);
        if (!container) {
          container = document.createElement('div');
          container.className = 'kso-microApp__container';
          container.id = id;
          container.role = 'global';
          document.body.appendChild(container);
        }
      }
    }
    container.appendChild(instance.$el);
  };
  Dialog.show = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    var args,
      name,
      options,
      callback,
      callbackClose,
      shower,
      distEntery,
      v,
      _args3 = arguments;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          args = Array.from(_args3);
          callback = function callback() {};
          callbackClose = function callbackClose() {};
          shower = /*#__PURE__*/function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(name) {
              var _ref4, beforeVisiable, configOpt, opt, visible, unwatch;
              return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) switch (_context2.prev = _context2.next) {
                  case 0:
                    // 保留字段(title、icons、icon)的属性初始到参数
                    // eslint-disable-next-line
                    _ref4 = mapping[name] || {}, beforeVisiable = _ref4.beforeVisiable, configOpt = _objectWithoutProperties(_ref4, _excluded2);
                    opt = merge(configOpt, options, {
                      callback: callback
                    });
                    beforeVisiable = beforeVisiable || function () {
                      return true;
                    };
                    _context2.next = 5;
                    return beforeVisiable(options);
                  case 5:
                    visible = _context2.sent;
                    if (!(visible === false)) {
                      _context2.next = 8;
                      break;
                    }
                    return _context2.abrupt("return", visible);
                  case 8:
                    if (isPlainObject(visible)) {
                      opt = merge(opt, visible);
                    }

                    /*
                     * @todo 遮层有动画可能会闪动
                     * 关闭其他的实例弹窗
                     * await Dialog.close()
                     */

                    Dialog(opt);
                    opt.isReplace ? instance.replace(name, opt) : instance.push(name, opt);
                    instance.pages = mapping;
                    instance.loading = false;
                    // 窗口隐藏后调用回调
                    unwatch = instance.$watch('dialogVisible', function (v) {
                      if (!v) {
                        var _instance, _instance$$destroy;
                        unwatch();
                        instances = instances.filter(function (i) {
                          return i !== instance;
                        });
                        callbackClose();
                        (_instance = instance) === null || _instance === void 0 || (_instance$$destroy = _instance.$destroy) === null || _instance$$destroy === void 0 || _instance$$destroy.call(_instance);
                        instance = undefined;
                      }
                    });
                  case 14:
                  case "end":
                    return _context2.stop();
                }
              }, _callee2);
            }));
            return function shower(_x) {
              return _ref3.apply(this, arguments);
            };
          }();
          /*
           * 解析参数
           * 3个参数
           */
          if (args.length > 3) {
            name = args[0];
            options = args[1] || {};
            callback = typeof args[2] === 'function' && args[2] || callback;
            callbackClose = typeof args[3] === 'function' && args[3] || callbackClose;
          } else if (args.length === 3) {
            // 3个参数
            if (typeof args[0] === 'string') {
              name = args[0];
              if (_typeof(args[1]) === 'object') {
                options = args[1];
                callback = typeof args[2] === 'function' && args[2] || callback;
              } else if (typeof args[1] === 'function') {
                options = {};
                callback = args[1];
                callbackClose = typeof args[2] === 'function' && args[2] || callbackClose;
              } else {
                options = {};
              }
            } else if (_typeof(args[0]) === 'object') {
              options = args[0];
              name = _entry_;
              options = isPlainObject(args[0]) && args[0] || {};
              callback = typeof args[1] === 'function' && args[1] || callback;
              callbackClose = typeof args[2] === 'function' && args[2] || callbackClose;
            } else {
              name = _entry_;
              options = {};
            }
          } else if (args.length === 2) {
            // 2个参数
            if (typeof args[0] === 'string') {
              name = args[0];
              options = _typeof(args[1]) === 'object' && args[1] || {};
              callback = typeof args[1] === 'function' && args[1] || callback;
            } else if (_typeof(args[0]) === 'object') {
              name = _entry_;
              options = args[0];
              callback = typeof args[1] === 'function' && args[1] || callback;
            } else if (typeof args[0] === 'function' && typeof args[1] === 'function') {
              name = _entry_;
              callback = args[1];
              callbackClose = args[1];
              options = {};
            } else {
              name = _entry_;
              callback = typeof args[0] === 'function' && args[0] || {};
              options = {};
            }
          } else if (args.length === 1) {
            /*
             * 1个参数
             * 是组件名的情况
             */
            if (typeof args[0] === 'string') {
              name = args[0];
              options = {};
            } else if (typeof args[0] === 'function') {
              // 是组件名的情况
              name = _entry_;
              options = {};
              callback = args[0];
            } else {
              name = _entry_;
              options = isPlainObject(args[0]) && args[0] || {};
            }
          } else {
            name = entry && entry.name;
            options = {};
          }
          if (!(typeof entry === 'function' && !name)) {
            _context3.next = 10;
            break;
          }
          _context3.next = 8;
          return entry(options);
        case 8:
          distEntery = _context3.sent;
          if (typeof distEntery === 'string') {
            name = distEntery;
          } else if (isPlainObject(distEntery)) {
            try {
              name = distEntery.name;
              delete distEntery.name;
            } catch (e) {
              // empty catch
            }
            merge(options, distEntery);
          }
        case 10:
          if (!name) {
            _context3.next = 17;
            break;
          }
          _context3.next = 13;
          return shower(name);
        case 13:
          v = _context3.sent;
          instance && (instance.visible = v !== false);
          _context3.next = 18;
          break;
        case 17:
          if (asyncs.length) {
            /*
            * 异步的组件加载，显示菊花
            * @todo beforeVisiable 会跳过
            */
            Dialog(merge(options, {
              loading: true
            }));
            Promise.all(asyncs).then(function () {
              shower(_entry_);
            });
            instance.visible = true;
          }
        case 18:
          // 增加额外字段来拓展支持PC内嵌的弹窗，用于PC内嵌复写style
          if (instance && options.isPC) {
            instance.pcOfficeClassName = 'k-pcOffice-dialog';
          }
          if (instance && options.isCloud) {
            instance.cloudClassName = 'k-web-cloud-dialog';
          }
          if (instance && options.isMf) {
            instance.mfClassName = options.isMf;
          }
          return _context3.abrupt("return", instance);
        case 22:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  Dialog.close = function () {
    var disposeAll = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return Promise.all(instances.map(function (vm) {
      return new Promise(function (resolve) {
        // 判断instance是不是游离态，是的话直接销毁掉
        if (disposeAll) {
          var node = vm.$el;
          while (node) {
            if (node === document.body) {
              break;
            }
            node = node.parentElement;
          }
          if (!node) {
            try {
              vm.$destroy();
            } catch (e) {}
            if (vm === instance) {
              instance = null;
            }
            vm = null;
            resolve();
          } else {
            vm.visible = false;
            vm.$nextTick(function () {
              return resolve();
            });
          }
        } else {
          vm.visible = false;
          vm.$nextTick(function () {
            return resolve();
          });
        }
      });
    })).then(function () {
      instances = [];
    });
  };
  Dialog.pop = function (action, data) {
    if (instance) {
      instance.onClose(action, data);
    }
  };
  Dialog.hide = function () {
    // instance.visible = false
    return Dialog.close();
  };
  Dialog.addPage = function (page) {
    var body = page.body;
    if (typeof body === 'function') {
      asyncs.push( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var _body_, _page_;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return page.body();
            case 2:
              _body_ = _context4.sent;
              _page_ = merge({}, page, {
                body: _body_
              });
              mapping[_body_.name] = _page_;
              if (page.body === entry.body) {
                _entry_ = _body_.name;
              }
              return _context4.abrupt("return", _page_);
            case 7:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      })));
    } else if (entry && entry.name) {
      var name = body.name;
      mapping[name] = page;
      _entry_ = _entry_ || entry.name === name && name;
    } else {
      var _name3 = body.name;
      mapping[_name3] = page;
    }
  };
  Dialog.setExtraClass = function (className) {
    instance.extraClass = className;
  };
  Dialog.getInstance = function () {
    return instance;
  };
  Dialog.preload = function (name) {
    var page = mapping[name];
    if (page && page.body && typeof page.body === 'function') {
      page.body();
    }
  };
  return Dialog;
}

export { DialogFactory as default };
